export const OperacionAFOPUTablaValorFields = {
    CodOperacionAFOPUTablaValor: 'codOperacionAFOPUTablaValor',
    IdOperacionAFOPU: 'idOperacionAFOPU',
    CodInstrumento: 'codOperacionAFOPUInstrumento',
    DescInstrumento: 'descInstrumento',
    CodOperacionTipo: 'codOperacionAFOPUOperacionTipo',
    DescOperacionTipo: 'descOperacionTipo',
    Valor: 'aforo',
    OrdenInstrumento: 'ordenInstrumento',
    OrdenOperacionTipo: 'ordenOperacionTipo',
    PermiteEditar: 'permiteEditar',
} as const

export const OperacionAFOPUFields = {
    CodOperacionAFOPU: 'idOperacionAFOPU',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    DescUnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    DescSectorComercial: 'descSectorComercial',

    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    Observaciones: 'observaciones',

    TablaValores: 'tablaValores',

    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',
    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
} as const


export const OperacionAFOUnidadNegocioFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
} as const;

export const OperacionAFOSectorComercialFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
    CodSectorComercial: 'codSectorComercial'
} as const;


export enum OperacionAFOPUTablaValorHistoricoFields {
    FechaModificacion = 'fechaMod',
    NombreUsuarioModificacion = 'nombreUsuarioMod',
    Observaciones = 'observaciones',
    Celdas = 'celdas'
}